// Landmark row: retain the Kabuki gate/mask and world props; repaint only bounded building art.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const LANDMARK_CUSTOM_FRONTS=['ramen','arcade'] as const;
const BUILDINGS=['ramen','kabuki','arcade'];
function grille(g:G,x:number,y:number,w:number,h:number){panel(g,x,y,w,h,K.metalLo);for(let j=4;j<h-3;j+=4)px(g,x+3,y+j,w-6,1,K.metalHi);}
export function paintKabukiLandmarks(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!BUILDINGS.includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();pipe(g,x+w-13,y+14,rh-28);
 if(b.id==='kabuki'){
  // Retain the existing mask, gate, lantern row and blade signs below the roof line.
  panel(g,x+28,y+69,91,57,K.concreteLo);grille(g,x+36,y+80,32,36);label(g,'STAGE',x+76,y+85,35,K.white);
  window(g,x+149,y+77,64,45,K.pink);for(let j=1;j<3;j++)px(g,x+151+j*20,y+79,2,41,K.metalHi);
  px(g,x+31,y+137,w-65,4,K.metalLo);for(let j=35;j<w-35;j+=14)px(g,x+j,y+127,2,14,K.metalHi);
  // Subtle framing supports the original landmark rather than covering its emblem.
  for(const xx of [x+3,x+w-6]){px(g,xx,fy+5,3,h-rh-10,K.metalHi);px(g,xx+1,fy+8,1,h-rh-16,K.pink);}
 }else if(b.id==='ramen'){
  panel(g,x+21,y+58,w-46,45,K.metalLo);fan(g,x+29,y+65);fan(g,x+65,y+65);px(g,x+98,y+72,40,10,K.metal);px(g,x+100,y+73,36,2,K.metalHi);
  grille(g,x+45,y+116,w-96,26);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.woodHi,K.woodLo,8);for(let j=8;j<w-8;j+=14)px(g,x+j,fy+4,2,h-rh-8,K.woodLo);
  label(g,'ラーメン',x+22,fy+6,w-44,K.amber,2);
  px(g,x+9,fy+35,w-18,7,K.ink);px(g,x+10,fy+35,w-20,2,K.amber);
  for(const xx of [x+13,x+w-65]){window(g,xx,fy+47,52,38,K.amber);px(g,xx+3,fy+74,46,4,K.woodHi);for(let j=10;j<47;j+=16){disc(g,xx+j,fy+70,6,3,K.white);px(g,xx+j-4,fy+71,8,3,K.metalLo);}}
  panel(g,x+w/2-22,fy+45,44,47,K.ink);for(let j=0;j<3;j++){px(g,x+w/2-20+j*14,fy+45,12,21,K.woodLo);px(g,x+w/2-18+j*14,fy+47,8,2,K.amber);}
  for(const xx of [x+7,x+w-8]){disc(g,xx,fy+62,5,9,K.amber);px(g,xx-3,fy+54,6,2,K.woodLo);}
  L(x+27,fy+12,w-54,16,K.amber,.22,true);
 }else{
  panel(g,x+20,y+55,w-44,65,K.metalLo);fan(g,x+28,y+64);grille(g,x+62,y+64,31,45);label(g,'POWER',x+23,y+130,w-50,K.white);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.wall,K.wallLo,7);
  label(g,'ゲーム',x+10,fy+7,w-20,K.pink,2);px(g,x+8,fy+35,w-16,3,K.pink);
  for(let j=0;j<3;j++){const xx=x+12+j*36;panel(g,xx,fy+46,31,43,K.metalLo);window(g,xx+4,fy+50,23,20,j===1?K.amber:K.pink);px(g,xx+3,fy+74,25,6,K.metalHi);px(g,xx+8,fy+71,2,5,K.ink);px(g,xx+21,fy+75,3,2,K.pink);}
  L(x+15,fy+13,w-30,16,K.pink,.22,true);
 }
 g.restore();
}
